<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="journalForm">
            <v-flex xs12>
              <v-card>
                <v-toolbar dense color="grey lighten-3" flat>
                  <v-icon v-if="newMode">mdi-plus</v-icon>
                  <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
                  <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
                  <v-toolbar-title v-if="newMode">Create Journal {{ journalForm.jrnlNo }} </v-toolbar-title>
                  <v-toolbar-title v-if="reviewMode">Edit Journal {{ journalForm.jrnlNo }} - {{ statusDesc }}</v-toolbar-title>
                  <v-toolbar-title v-if="queryMode">View Existing Journal {{ journalForm.jrnlNo }} - {{ statusDesc }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <!--New & Review-->
                    <v-layout row wrap v-if="!queryMode">
                      <v-flex md4 xs12>
                        <cal-picker
                          v-model="journalForm.tranDate"
                          :label="journalLabel.tranDate"
                          :data-vv-as="journalLabel.tranDate"
                          data-vv-name="journalForm.tranDate"
                          :error-messages="errors.collect('journalForm.tranDate')"
                          @input="doTranDate"
                          v-validate="tranDateValidation"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-checkbox color="primary" :label="journalLabel.accountingPeriodAE" v-model="journalForm.accountingPeriodAE"></v-checkbox>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          v-model="journalForm.accountingMth"
                          :label="journalLabel.accountingMth"
                          :disabled="isAcctPerAE"
                          :error-messages="errors.collect('journalForm.accountingMth')"
                          data-vv-name="journalForm.accountingMth"
                          :data-vv-as="journalLabel.accountingMth"
                          v-validate="'entry|numeric|max:2'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          v-model="journalForm.accountingYr"
                          :label="journalLabel.accountingYr"
                          :disabled="isAcctPerAE"
                          :error-messages="errors.collect('journalForm.accountingYr')"
                          data-vv-name="journalForm.accountingYr"
                          :data-vv-as="journalLabel.accountingYr"
                          v-validate="'entry|numeric|max:4'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="amountcurrencies"
                          v-model="journalForm.curr"
                          :label="journalLabel.curr"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('journalForm.curr')"
                          data-vv-name="journalForm.curr"
                          :data-vv-as="journalLabel.curr"
                          clearable
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-checkbox color="primary" :label="journalLabel.exchangeRateAE" v-model="journalForm.exchangeRateAE"></v-checkbox>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          ref="exchangeRate"
                          v-model="journalForm.exchangeRate"
                          :label="journalLabel.exchangeRate"
                          :disabled="isExChangeRateAE"
                          :error-messages="errors.collect('journalForm.exchangeRate')"
                          data-vv-name="journalForm.exchangeRate"
                          :data-vv-as="journalLabel.exchangeRate"
                          v-num-mask="{ negative: true, intScale: 10, decScale: 2 }"
                          @blur="setValue(), calculateLocalAmount()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12 v-if="!newMode">
                        <v-subheader class="queryLabel">{{ journalLabel.status }}</v-subheader>
                        <div class="queryValue" v-for="item in filterStatusList" :key="item.label">{{ item.label }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          ref="totalAdj"
                          v-model="journalForm.totalAdj"
                          :label="journalLabel.totalAdj"
                          :error-messages="errors.collect('journalForm.totalAdj')"
                          data-vv-name="journalForm.totalAdj"
                          :data-vv-as="journalLabel.totalAdj"
                          v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                          v-validate="'mask_min_value:0.01'"
                          @blur="calculateLocalAmount()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          ref="localAdj"
                          v-model="journalForm.localAdj"
                          :label="journalLabel.localAdj"
                          :error-messages="errors.collect('journalForm.localAdj')"
                          data-vv-name="journalForm.localAdj"
                          :data-vv-as="journalLabel.localAdj"
                          disabled
                          v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-textarea
                          v-model="journalForm.reasonAdj"
                          :label="journalLabel.reasonAdj"
                          :error-messages="errors.collect('reasonAdj')"
                          v-validate="'max:1000|entry'"
                          data-vv-name="reasonAdj"
                          :data-vv-as="journalLabel.reasonAdj"
                          :counter="1000"
                          :rows="10"
                        ></v-textarea>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="journalForm.glAcctNo"
                          :label="journalLabel.glAcctNo"
                          :error-messages="errors.collect('journalForm.glAcctNo')"
                          data-vv-name="journalForm.glAcctNo"
                          :data-vv-as="journalLabel.glAcctNo"
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="showGlAcctNoHelpList = true" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="journalForm.desc"
                          :label="journalLabel.desc"
                          :error-messages="errors.collect('journalForm.desc')"
                          data-vv-name="journalForm.desc"
                          :data-vv-as="journalLabel.desc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          ref="adj"
                          v-model="journalForm.adj"
                          :label="journalLabel.adj"
                          :error-messages="errors.collect('journalForm.adj')"
                          data-vv-name="journalForm.adj"
                          :data-vv-as="journalLabel.adj"
                          v-validate="this.adjValidateField"
                          v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12>
                        <v-card>
                          <v-layout row wrap>
                            <v-flex class="text-right" v-if="!queryMode">
                              <v-btn class="mr-2" color="primary" @click.native="checkAdjValidate('doInsertGL')">
                                <span>Insert GL</span>
                                <v-icon right dark>mdi-plus</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex xs12>
                              <v-data-table
                                v-bind:headers="listGlDetHeaders"
                                v-bind:items="glDetItems"
                                item-key="key"
                                :loading="loading"
                                :no-data-text="noDataText"
                              >
                                <template v-slot:item="row"
                                  ><tr>
                                    <td v-for="column in selectedGLDetColumns" :key="column">{{ row.item[column] }}</td>
                                    <td class="table-action-header">
                                      <table-action :rowData="row" remove @remove="doDelete(row.item)"></table-action>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="reviewMode">
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.createdBy }}</v-subheader>
                        <div class="queryValue">{{ journalForm.createdBy }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.createdDate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.createdDate }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.modifiedBy }}</v-subheader>
                        <div class="queryValue">{{ journalForm.modifiedBy }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.modifiedDate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.modifiedDate }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.statusBy }}</v-subheader>
                        <div class="queryValue">{{ journalForm.statusBy }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.statusDate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.statusDate }}</div>
                      </v-flex>
                    </v-layout>
                    <!--End New & Review-->

                    <!-- Query -->
                    <v-layout row wrap v-if="queryMode">
                      <v-flex md4 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.tranDate }}</v-subheader>
                        <div class="queryValue">{{ convertDate(journalForm.tranDate) }}</div>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-checkbox
                          color="primary"
                          :label="journalLabel.accountingPeriodAE"
                          v-model="journalForm.accountingPeriodAE"
                          disabled
                        ></v-checkbox>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.accountingMth }}</v-subheader>
                        <div class="queryValue">{{ journalForm.accountingMth }}</div>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.accountingYr }}</v-subheader>
                        <div class="queryValue">{{ journalForm.accountingYr }}</div>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.curr }}</v-subheader>
                        <div class="queryValue" v-for="item in filterCurrencyList" :key="item.label">{{ item.label }}</div>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-checkbox color="primary" :label="journalLabel.exchangeRateAE" v-model="journalForm.exchangeRateAE" disabled></v-checkbox>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.exchangeRate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.exchangeRate }}</div>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.status }}</v-subheader>
                        <div class="queryValue" v-for="item in filterStatusList" :key="item.label">{{ item.label }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.totalAdj }}</v-subheader>
                        <div class="queryValue">{{ journalForm.totalAdj }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.localAdj }}</v-subheader>
                        <div class="queryValue">{{ journalForm.localAdj }}</div>
                      </v-flex>
                      <v-flex md12 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.reasonAdj }}</v-subheader>
                        <div class="queryValue">{{ journalForm.reasonAdj }}</div>
                      </v-flex>
                      <v-flex xs12>
                        <v-card>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-data-table
                                v-bind:headers="listGlDetHeaders"
                                v-bind:items="glDetItems"
                                item-key="key"
                                :loading="loading"
                                :no-data-text="noDataText"
                              >
                                <template v-slot:item="row"
                                  ><tr>
                                    <td v-for="column in selectedGLDetColumns" :key="column">{{ row.item[column] }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.createdBy }}</v-subheader>
                        <div class="queryValue">{{ journalForm.createdBy }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.createdDate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.createdDate }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.modifiedBy }}</v-subheader>
                        <div class="queryValue">{{ journalForm.modifiedBy }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.modifiedDate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.modifiedDate }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.statusBy }}</v-subheader>
                        <div class="queryValue">{{ journalForm.statusBy }}</div>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-subheader class="queryLabel">{{ journalLabel.statusDate }}</v-subheader>
                        <div class="queryValue">{{ journalForm.statusDate }}</div>
                      </v-flex>
                    </v-layout>

                    <!-- CBO Added: Oct-05-2020 Comments -->
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg12 xs12 order-lg1 order-xs2>
                          <common-comments
                            :commentRefNo="this.commentRefNo"
                            :commentTranType="this.commentTranType"
                            :requestComCount="true"
                            @assign-com-count-info="assignComCount"
                          ></common-comments>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <!--End Query-->

                    <v-btn color="red darken-1" dark class="mr-2 mt-2" @click.native="doCancel">
                      Cancel
                      <v-icon right dark>mdi-cancel</v-icon>
                    </v-btn>
                    <v-btn class="mr-2 mt-2" v-if="!queryMode" color="primary" dark @click.native="checkAdjValidate('doSaveReview')" :loading="submitting">
                      Save & Review
                      <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn class="mr-2 mt-2"
                      v-if="!queryMode && checkAccess([permissionKeys.perm_044050])"
                      color="brown"
                      dark
                      @click="doSendApproval('CREATE_SEND_APPROVAL')"
                      :loading="submitting"
                    >
                      Send For Approval
                      <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn class="mr-2 mt-2"
                      v-if="reviewMode && checkAccess([permissionKeys.perm_044055])"
                      color="red darken-1"
                      dark
                      @click="doReject('REJECT')"
                      :loading="submitting"
                    >
                      Reject
                      <v-icon right>mdi-cancel</v-icon>
                    </v-btn>
                    <v-btn class="mr-2 mt-2"
                      v-if="!queryMode && checkAccess([permissionKeys.perm_044060])"
                      color="green darken-1"
                      dark
                      @click="doApprovePost('CREATE_APPROVE_POST')"
                      :loading="submitting"
                    >
                      Approve & Post
                      <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn class="mr-2 mt-2" color="blue" dark @click.native="doPrint" :loading="submitting">
                      Journal Record
                      <v-icon right>mdi-printer</v-icon>
                    </v-btn>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </form>
        </v-flex>

        <v-dialog v-model="showCurrencyHelpList" width="1280px">
          <cr-currency-help-list @close="showCurrencyHelpList = false" @assign-currency="assignCurr"></cr-currency-help-list>
        </v-dialog>

        <v-dialog v-model="showGlAcctNoHelpList" width="1280px">
          <gl-acct-no-help-list2
            @close="showGlAcctNoHelpList = false"
            objData="screen_2"
            @assign-gl-acct-info="assignGlAcctInfo"
          ></gl-acct-no-help-list2>
        </v-dialog>

        <confirm v-model="promptProceed" @ok="doProceed">
          {{ journalInProgressLabel }}
        </confirm>

        <v-dialog v-model="processingFlag" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Processing...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showErrorDialog" width="800px">
          <v-card>
            <v-card-title primary-title>
              <div>
                <div class="headline">System Information</div>
                <span class="grey--text">An error occurred when creating Journal.</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-if="messages.length > 0" class="pb-3">
                <v-subheader>Error Details:</v-subheader>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                    {{ error.message }}
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="promptCannotReject" width="50%" persistent>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Warning
                  <v-spacer></v-spacer>
                  <v-btn text icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs12>
                        {{ warnMsg }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-dialog>

        <v-flex v-if="!queryMode">
          <prompt-leave v-if="showPromptLeave" title="Journal" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></prompt-leave>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import CrCurrencyHelpList from '@/components/core/common/dialog/CrCurrencyHelpList'
import { journalListMixin } from '@/mixins/accounting/journal/journalListMixin'
import { journalAjaxMixin } from '@/mixins/accounting/journal/journalAjaxMixin'
import { formatDisplayDateTime2, formatDisplayDate } from '@/utils/date'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import GlAcctNoHelpList2 from '@/components/core/common/dialog/GlAcctNoHelpList2'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { permissionKeys } from '@/mixins/global/permissionKey'
import { journalFilterMixin } from '@/mixins/accounting/journal/journalFilterMixin'
import CommonComments from '@/components/core/accounting/CommonComments'

export default {
  data() {
    return {
      journalLabel: {
        tranDate: 'Transaction Date',
        accountingPeriodAE: 'Accounting Period',
        accountingMth: 'Accounting Month',
        accountingYr: 'Accounting Year',
        curr: 'Currency',
        exchangeRateAE: 'Exchange Rate',
        exchangeRate: '',
        totalAdj: 'Total Amount',
        localAdj: 'Local Amount',
        reasonAdj: 'Reason for Adjustment',
        glAcctNo: 'GL Account No.',
        desc: 'Description',
        adj: 'Adjustment',
        createdBy: 'Created By',
        createdDate: 'on',
        modifiedBy: 'Modified By',
        modifiedDate: 'on',
        statusBy: 'Status By',
        statusDate: 'on',
        status: 'Status'
      },
      journalForm: {
        actionName: null,
        branch: null,
        fund: null,
        suffix: null,
        tranDate: null,
        accountingPeriodAE: true,
        accountingMth: null,
        accountingYr: null,
        curr: null,
        exchangeRateAE: true,
        exchangeRate: '1.00',
        totalAdj: '0.00',
        localAdj: null,
        reasonAdj: '',
        glAcctNo: null,
        desc: null,
        adj: '0.00',
        glAdjDetList: [],
        jrnlNo: null,
        validAcctPer: false,
        doInsert: true,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        statusBy: null,
        statusDate: null,
        status: null
      },
      statusDesc: null,
      amountcurrencies: [],
      showCurrencyHelpList: false,
      baseCurrency: '',
      showGlAcctNoHelpList: false,
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      currencyrate: {},
      itemNo: 0,
      processingFlag: false,
      showPromptLeave: true,
      showErrorDialog: false,
      loading: false,
      adjValidateField: undefined,
      permissionKeys: permissionKeys,
      currentStatus: null,
      promptProceed: false,
      journalInProgressLabel: 'Journal still in Progress - do you want to proceed?',
      promptCannotReject: false,
      warnMsg: '',
      comment: '',
      paginationGlDet: {
        page: 1
      }
    }
  },
  computed: {
    journalId() {
      return this.$store.state.journal.journal.journalId
    },
    tranDateValidation() {
      return 'required|valAcctPer:' + this.journalForm.validAcctPer
    },
    adjValidation() {
      if (this.journalForm.doInsert === true) {
        return 'entry|not_zero'
      } else {
        return ''
      }
    },
    isAcctPerAE: function () {
      if (this.journalForm.accountingPeriodAE === true) {
        return true
      } else {
        return false
      }
    },
    isExChangeRateAE: function () {
      if (this.journalForm.exchangeRateAE === true) {
        return true
      } else {
        return false
      }
    },
    displayErrorDialog() {
      return this.messages
    },
    filterCurrencyList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.journalForm.curr
      })
    },
    filterStatusList() {
      return this.statusList.filter((list) => {
        return list.value === this.journalForm.status
      })
    },
    apiURI() {
      return this.$store.state.payment.menu
    },
    commentRefNo() {
      return this.journalForm.jrnlNo
    },
    commentTranType() {
      // No TranType available in this screen
      return ''
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      this.getCommonDataList('amountcurrencies')
      this.getAcctJournalMenuLink()
      if (this.newMode) {
        this.journalForm.tranDate = new Date()
        this.getBaseCurr('baseCurrency')
        this.doTranDate()
        // this.journalForm.branch = this.token.userBranch
      } else {
        this.loading = true
        this.journalForm.jrnlNo = this.journalId.jrnlNo
        this.statusDesc = this.journalId.statusDesc
        this.currentStatus = this.journalId.status
        this.performReview().then((result) => {
          if (result) {
            this.getGlAdjDetList()
            if (!this.queryMode) {
              this.valAcctPer(this.journalForm)
            }
          }
        })
      }
    },
    doSaveJournal(actionName) {
      this.resetMessages()
      this.journalForm.doInsert = false
      this.journalForm.adj = '0.00'
      this.adjValidateField = 'entry'
      if (this.adjValidateField !== undefined) {
        this.$validator.validateAll('journalForm').then((result) => {
          this.$validator.errors.remove('journalForm.adj')
          if (result) {
            this.journalForm.glAdjDetList = this.glDetItems
            this.journalForm.status = 'IP'
            this.processingFlag = true
            if (this.newMode) {
              this.journalForm.actionName = actionName
              this.performSave()
            } else {
              this.journalForm.actionName = 'UPDATE_SAVE_REVIEW'
              this.performSave()
            }
          } else {
            this.promptFieldCheck()
          }
        })
      }
    },
    doSendApproval(actionName) {
      this.resetMessages()
      this.journalForm.doInsert = false
      this.journalForm.adj = '0.00'
      this.adjValidateField = 'entry'
      this.$validator.validateAll('journalForm').then((result) => {
        if (result) {
          this.journalForm.glAdjDetList = this.glDetItems
          this.journalForm.status = 'WA'
          this.processingFlag = true
          if (this.newMode) {
            this.journalForm.actionName = actionName
            this.performSave()
          } else {
            this.journalForm.actionName = 'UPDATE_SEND_APPROVAL'
            this.performSave()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doReject(actionName) {
      if (this.reviewMode) {
        if (this.currentStatus === 'WA') {
          if (this.comment !== '') {
            this.journalForm.actionName = actionName
            this.journalForm.status = 'RJ'
            this.performSave()
          } else {
            this.warnMsg = 'Must add comment'
            this.promptCannotReject = true
          }
        } else {
          this.warnMsg = 'Journal not valid for Rejection'
          this.promptCannotReject = true
        }
      }
    },
    doApprovePost(actionName) {
      this.resetMessages()
      this.journalForm.doInsert = false
      this.journalForm.adj = '0.00'
      this.adjValidateField = 'entry'
      this.$validator.validateAll('journalForm').then((result) => {
        if (result) {
          this.journalForm.glAdjDetList = this.glDetItems
          this.processingFlag = true
          if (this.newMode) {
            this.journalForm.status = 'AP'
            this.journalForm.actionName = actionName
            this.performSave()
          } else {
            if (this.currentStatus === 'IP') {
              this.processingFlag = false
              this.promptProceed = true
            } else {
              this.journalForm.status = 'AP'
              this.journalForm.actionName = 'UPDATE_APPROVE_POST'
              this.performSave()
            }
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doProceed() {
      this.processingFlag = true
      this.journalForm.status = 'AP'
      this.journalForm.actionName = 'UPDATE_APPROVE_POST'
      this.performSave()
    },
    closeDialog() {
      this.promptCannotReject = false
    },
    doCancel() {
      this.$router.push({ name: 'journalTransaction' }).catch(() => {})
    },
    doPrint() {
      if (this.reviewMode || this.queryMode) {
        this.journalForm.jrnlNo = this.journalId.jrnlNo
        this.doExportAcctJournlRecord()
      }
    },
    doDelete(data) {
      this.journalForm.adj = '0.00'
      for (var i = 0; i < this.glDetItems.length; i++) {
        if (
          this.glDetItems[i].branch === data.branch &&
          this.glDetItems[i].glAcctNo === data.glAcctNo &&
          this.glDetItems[i].fund === data.fund &&
          this.glDetItems[i].suffix === data.suffix
        ) {
          this.$delete(this.glDetItems, i)
        }
      }
    },
    doInsertGL() {
      this.journalForm.doInsert = true
      this.adjValidateField = 'required|not_zero'
      this.resetMessages()
      this.$validator.validateAll('journalForm').then((result) => {
        if (result) {
          const glDetailList = {
            branch: this.journalForm.branch,
            glAcctNo: this.journalForm.glAcctNo,
            fund: this.journalForm.fund,
            suffix: this.journalForm.suffix,
            desc: this.journalForm.desc,
            curr: this.journalForm.curr,
            adj: this.journalForm.adj,
            local: formatPrice(removeFormatNumber(this.journalForm.adj) * this.journalForm.exchangeRate),
            rate: this.journalForm.exchangeRate,
            rateAE: this.journalForm.exchangeRateAE
          }
          if (this.journalForm.adj === '0.00' || this.journalForm.adj === undefined) {
            this.$validator.validateAll('journalForm')
            this.adjValidateField = undefined
          } else if (this.journalForm.adj !== '0.00') {
            this.glDetItems.push(glDetailList)
            this.journalForm.glAcctNo = ''
            this.journalForm.desc = ''
            this.journalForm.adj = '0.00'
            this.journalForm.doInsert = false
            this.adjValidateField = undefined
            this.setAdj()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    setAdj() {
      this.$refs.adj.$el.cleave.setRawValue(this.journalForm.adj)
      this.journalForm.adj = formatPrice(this.$refs.adj.$el.cleave.getRawValue())
    },
    checkAdjValidate(button) {
      if (button === 'doInsertGL') {
        if (this.journalForm.adj === '0.00' || this.journalForm.adj === undefined) {
          this.journalForm.doInsert = true
          this.adjValidateField = 'required|not_zero'
          this.$validator.validateAll('journalForm').then((success) => {
            if (success) {
              this.doInsertGL()
            } else {
              this.promptFieldCheck()
            }
          })
        } else {
          this.journalForm.doInsert = false
          this.adjValidateField = 'entry'
          this.doInsertGL()
        }
      } else if (button === 'doSaveReview') {
        this.journalForm.doInsert = false
        this.adjValidateField = 'entry'
        this.doSaveJournal('CREATE_SAVE_REVIEW')
      }
    },
    reCalculateGLAdjDet() {
      for (var i = 0; i < this.glDetItems.length; i++) {
        if (this.glDetItems[i]) {
          this.glDetItems[i].curr = this.journalForm.curr
          this.glDetItems[i].local = formatPrice(removeFormatNumber(this.glDetItems[i].adj) * this.journalForm.exchangeRate)
          this.glDetItems[i].rate = this.journalForm.exchangeRate
          this.glDetItems[i].rateAE = this.journalForm.exchangeRateAE
        }
      }
    },
    doTranDate() {
      this.valAcctPer(this.journalForm).then((result) => {
        if (result) {
          if (this.journalForm.validAcctPer) {
            if (this.journalForm.accountingPeriodAE) {
              this.journalForm.accountingMth = this.journalForm.tranDate.getMonth() + 1
              this.journalForm.accountingYr = this.journalForm.tranDate.getFullYear()
            }
          }
        }
      })
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    assignCurr(curr) {
      this.journalForm.curr = curr
      this.showCurrencyHelpList = false
      this.getCommonData('accountdata', curr)
    },
    assignBaseCurr(data) {
      this.journalForm.curr = data[0]
      this.calculateLocalAmount()
    },
    assignCurrRate(data) {
      this.journalForm.exchangeRate = data
      this.calculateLocalAmount()
    },
    assignGlAcctInfo(data) {
      this.journalForm.branch = data.branch
      this.journalForm.glAcctNo = data.glacctNo
      this.journalForm.fund = data.fund
      this.journalForm.suffix = data.acctNoSfx
      this.journalForm.desc = data.description
    },
    calculateLocalAmount() {
      this.journalForm.localAdj = formatPrice(removeFormatNumber(this.journalForm.totalAdj) * this.journalForm.exchangeRate)
      this.setValue()
    },
    setValue() {
      this.$refs.exchangeRate.$el.cleave.setRawValue(this.journalForm.exchangeRate)
      this.journalForm.exchangeRate = formatPrice(this.$refs.exchangeRate.$el.cleave.getRawValue())
      this.$refs.totalAdj.$el.cleave.setRawValue(this.journalForm.totalAdj)
      this.journalForm.totalAdj = formatPrice(this.$refs.totalAdj.$el.cleave.getRawValue())
      this.$refs.localAdj.$el.cleave.setRawValue(this.journalForm.localAdj)
      this.journalForm.localAdj = formatPrice(this.$refs.localAdj.$el.cleave.getRawValue())
    },
    assignComCount(data) {
      if (data > 0) {
        this.comment = 'AddedComment'
      } else {
        this.comment = ''
      }
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('jrnl'))
    this.$store.commit('JOURNAL_COMMIT_KEY', jsonData)
    if (this.journalId.tranMode !== '') {
      if (this.journalId.tranMode === 'New') {
        this.newMode = true
      } else if (this.journalId.tranMode === 'Review') {
        this.reviewMode = true
      } else if (this.journalId.tranMode === 'Query') {
        this.queryMode = true
        this.skipPrompt = true
      }
    }
    this.$validator.extend('valAcctPer', {
      getMessage(field, args) {
        return 'Account Period End Date not found in Accounting Period file.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var acctPeriod = args[0]
        if (acctPeriod === 'true') {
          return true
        } else {
          return false
        }
      }
    })
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'journalForm.curr': function () {
      if (!this.queryMode && this.journalForm.exchangeRateAE) {
        this.getCommonData('currencyrate', this.journalForm.curr, formatDisplayDateTime2(this.journalForm.tranDate))
      }
    },
    'journalForm.exchangeRate': function () {
      this.reCalculateGLAdjDet()
    },
    'journalForm.accountingPeriodAE': function () {
      this.doTranDate()
    }
  },
  mixins: [MessageMixin, commonAjaxMixin, journalListMixin, journalAjaxMixin, promptOnExitMixin, journalFilterMixin],
  components: {
    CrCurrencyHelpList,
    GlAcctNoHelpList2,
    PromptLeave,
    CommonComments
  }
}
</script>
